/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Node_CopiesInputs */

const en_fw_node_copies = /** @type {(inputs: Fw_Node_CopiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4M+ copies in print`)
};

const zh_fw_node_copies = /** @type {(inputs: Fw_Node_CopiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`累计发行 400 万部以上`)
};

/**
* | output |
* | --- |
* | "4M+ copies in print" |
*
* @param {Fw_Node_CopiesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_node_copies = /** @type {((inputs?: Fw_Node_CopiesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Node_CopiesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_node_copies(inputs)
	return zh_fw_node_copies(inputs)
});
export { fw_node_copies as "fw.node.copies" }